export default __webpack_public_path__ + "2b35c7e66591ff9b4642d60c9eb62a28.svg";